import { create } from 'zustand';
import type { ProductOfferResponse } from '../types/api';
import i18n from "../i18n";

export const defaultApiErrorState = {
  isError: false,
  message: i18n.t("error_Popup_Title"),
  retryText: i18n.t("try_Again"),
  cancelText: i18n.t("close"),
};
export interface CustomWindow extends Window {
  lang?: string;
  rtl?: boolean;
  x_api_key?: string;
  apigee_bm_x_api_key?: string;
  clientToken?: string;
}

export interface GlobalStore {
  lang?: string;
  rtl?: boolean;
  apiKey?: string;
  token?: string;
  loading: boolean;
  formState?: any;
  graphqlResponse: { data: ProductOfferResponse };
  eligibleProducts?: any;
  shoppingCart?: any;
  productKey: string;
  apiError?: { isError?: boolean, message?: string, retryText?: string, cancelText?: string };
  coverageError?: boolean;
  bypassOTPError?: boolean;
  otpReferenceId?: string;
  requestRefNumber?: string;
  correlationId?: string;
  locationState?: any;
  qualifyProductOffersResponse?: any;
  isMeshExtenderOpted?: boolean;
  setLang: (lang: string) => void;
  setRtl: (rtl: boolean) => void;
  setApiKey: (key?: string) => void;
  setToken: (token?: string) => void;
  setLoading: (flag: boolean) => void;
  setFormState: (formState: any) => void;
  setQraphqlResponse: (res: { data: ProductOfferResponse }) => void;
  setEligibleProducts: (products: any) => void;
  setShoppingCart: (cart: any) => void;
  setProductKey: (key: string) => void;
  setApiError: (error: { message?: string, retryText?: string, cancelText?: string, isError?: boolean }) => void;
  setOtpReferenceId: (refId: string) => void;
  setCoverageError: (flag: boolean) => void;
  setBypassOTPError: (flag: boolean) => void;
  setRequestRefNumber: (refNum: string) => void;
  setCorrelationId: (correlationId: string) => void;
  setLocationState: (locationData: any) => void;
  setQualifyProductOffersResponse: (res: any) => void;
  setIsMeshExtenderOpted: (flag: boolean) => void;
}

export const useGlobalStore = create<GlobalStore>((set) => {
  const storedProductKey = sessionStorage.getItem('productKey');
  const initialApiError = !storedProductKey
    ? { ...defaultApiErrorState, isError: true, cancelText: "" }
    : defaultApiErrorState;
  return ({
    // Initial State
    loading: false,
    formState: null,
    productOffer: null,
    eligibleProducts: null,
    lang: 'en',
    rtl: false,
    apiKey: '',
    token: '',
    productKey: storedProductKey ?? '',
    graphqlResponse: { data: {} as ProductOfferResponse },
    shoppingCart: null,
    apiError: initialApiError,
    coverageError: false,
    otpReferenceId: "",
    requestRefNumber: "",
    correlationId: "",
    locationState: {
      coords: {
        lat: 24.7135517,
        lng: 46.6752957
      },
      address: "Riyadh Saudi Arabia"
    },
    qualifyProductOffersResponse: null,
    isMeshExtenderOpted: false,
    bypassOTPError: false,
    // Setters
    setApiKey: (apiKey) => set({ apiKey }),
    setToken: (token) => set({ token }),
    setLoading: (loading) => set({ loading }),
    setFormState: (formState) => set({ formState: formState }),
    setQraphqlResponse: (res: { data: ProductOfferResponse }) => set({ graphqlResponse: res }),
    setEligibleProducts: (products) => set({ eligibleProducts: products }),
    setShoppingCart: (cart) => set({ shoppingCart: cart }),
    setLang: (lang) => set({ lang }),
    setRtl: (rtl) => set({ rtl }),
    setProductKey: (key) => {
      sessionStorage.setItem('productKey', key);
      set({ productKey: key });
    },
    setApiError: (error) => set({ apiError: {...defaultApiErrorState, ...error} }),
    setOtpReferenceId: (refId) => set({ otpReferenceId: refId }),
    setCoverageError: (flag) => set({ coverageError: flag }),
    setRequestRefNumber: (refNum) => set({ requestRefNumber: refNum }),
    setCorrelationId: (correlationId) => set({ correlationId }),
    setLocationState: (locationState) => set({ locationState }),
    setQualifyProductOffersResponse: (res) => set({ qualifyProductOffersResponse: res }),
    setIsMeshExtenderOpted: (flag) => set({ isMeshExtenderOpted: flag }),
    setBypassOTPError: (flag) => set({ bypassOTPError: flag }),
  })
});